module.exports = __webpack_public_path__ + "img/him_logo@2x.f1b68b05.png";